import * as React from 'react';
import { translate } from 'react-i18next';
const { connect } = require('react-redux');
import * as c from 'models/constants';
import { IStore } from 'redux/IStore';
import { IUserCardAction, IUserCardData } from 'models/user/usercard';
import { followUser, getUserCardByCode, unfollowItem } from 'redux/modules/user/usercard';
import renderIcon from 'helpers/renderIcon';
import { formatInteger, getProfileTabUrl } from 'helpers/common';
import { browserHistory } from 'react-router';

interface IProps {
	userId: string;
	userCard?: IUserCardData;
	getUserCardByCode?: (userCode: string) => IUserCardAction;
	followUser?: (id: string, isUserCardFollowButton: boolean) => IUserCardAction;
	unfollowUser?: (id: string, type: string, isUserCardFollowButton: boolean) => IUserCardAction;
	t?: (key: string) => string;
}

@connect(
	(state: IStore) => ({
		userCard: state.usercard,
	}),
	(dispatch) => ({
		getUserCardByCode: (userCode: string) => dispatch(getUserCardByCode(userCode)),
		followUser: (id: string, isUserCardFollowButton: boolean) => dispatch(followUser(id, isUserCardFollowButton)),
		unfollowUser: (id: string, type: string, isUserCardFollowButton: boolean) =>
			dispatch(unfollowItem(id, type, isUserCardFollowButton)),
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ArticleAuthorBanner extends React.Component<IProps> {
	constructor(props) {
		super(props);

		this.handleOnEditProfileClick = this.handleOnEditProfileClick.bind(this);
		this.followUser = this.followUser.bind(this);
		this.unfollowUser = this.unfollowUser.bind(this);
	}

	componentDidMount() {
		if (this.props.userId) {
			this.props.getUserCardByCode(this.props.userId);
		}
	}
	private handleOnEditProfileClick() {
		browserHistory.push('/userprofile');
	}
	public followUser() {
		this.props.followUser(this.props.userCard.usercard.id, true);
	}
	public unfollowUser() {
		const userCard = this.props.userCard.usercard;
		this.props.unfollowUser(userCard.id, JSON.parse(userCard.entityId).type, true);
	}

	public handleOnUserClick() {
		browserHistory.push(`/profile/${this.props.userCard.usercard.id}${getProfileTabUrl('default')}`);
	}

	render() {
		const { userCard, t } = this.props;
		const { isMyProfile, usercard } = userCard;
		return (
			<div className="articleAuthorBanner container">
				<div className="row">
					<div className="col-lg-9">
						<p className="p12 green">{t('Magazine_Section_Manage_Common_Author').toUpperCase()}</p>
						<h2 className="name" onClick={() => this.handleOnUserClick()}>
							{userCard?.usercard?.name}
						</h2>
						<div className="infoContainer d-flex flex-row">
							<div
								className={`bsPortalBtn ${
									userCard.isFollowed ? 'btnEllipseGreyWhite' : 'btnEllipseGreenWhite'
								} text-capitalize`}
								onClick={
									isMyProfile
										? this.handleOnEditProfileClick
										: userCard.isFollowed
										  ? this.unfollowUser
										  : this.followUser
								}
							>
								{isMyProfile
									? t('User_UserCard_EditProfile')
									: userCard.isFollowed
									  ? t('BSPortal_Common_Unfollow')
									  : t('BSPortal_Common_Follow')}
							</div>
							<div className="followStats d-flex flex-row align-items-center">
								{renderIcon('followers')}
								<p className="p14 text-lowercase">
									<span className="count">{formatInteger(usercard?.followersCount)}</span>&nbsp;
									{t('User_UserCard_Followers')}
								</p>
							</div>
							{/* // TODO Listings */}
						</div>
					</div>
					<div className="photoContainer col-lg-3">
						<div className="filter">
							<img className="photo" src={usercard?.picture} onClick={() => this.handleOnUserClick()} />
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export { ArticleAuthorBanner };
